(() => {
  const init = (root) => {
    if (!root || root.dataset.pdpReady === 'true') return;
    root.dataset.pdpReady = 'true';

    const dataEl = document.getElementById(root.dataset.productDataId);
    if (!dataEl) return;

    let data;
    try { data = JSON.parse(dataEl.textContent); } catch { return; }

    const variantButtons = [...root.querySelectorAll('[data-option-button]')];
    const mainImage = root.querySelector('[data-main-image]');
    const thumbs = [...root.querySelectorAll('[data-thumb-index]')];
    const mediaCount = root.querySelector('[data-media-count]');
    const priceEls = [...root.querySelectorAll('[data-current-price]')];
    const compareEls = [...root.querySelectorAll('[data-compare-price]')];
    const discountEls = [...root.querySelectorAll('[data-discount-badge]')];
    const totalEls = [...root.querySelectorAll('[data-total-price]')];
    const stockEls = [...root.querySelectorAll('[data-stock-status]')];
    const addButtons = [...root.querySelectorAll('[data-add-to-cart]')];
    const qtyEl = root.querySelector('[data-quantity-value]');
    const sticky = document.querySelector('[data-pdp-sticky]');
    const mainAdd = root.querySelector('[data-main-add]');
    const zoomDialog = root.querySelector('[data-zoom-dialog]');
    const zoomImage = root.querySelector('[data-zoom-image]');
    const selectedSku = root.querySelector('[data-selected-sku]');

    let quantity = 1;
    let currentVariant = data.variants.find(v => String(v.id) === String(data.selectedVariantId)) || data.variants[0];

    const money = (cents) => new Intl.NumberFormat('en-IN', {
      style: 'currency',
      currency: data.currency || 'INR',
      maximumFractionDigits: 2
    }).format((Number(cents) || 0) / 100);

    const selectedValues = () => {
      const result = {};
      variantButtons.forEach(btn => {
        if (btn.getAttribute('aria-pressed') === 'true') result[btn.dataset.position] = btn.dataset.value;
      });
      return result;
    };

    const setMainImage = (index) => {
      const image = data.images[index];
      if (!image || !mainImage) return;
      mainImage.removeAttribute('srcset');
      mainImage.src = image.src;
      mainImage.alt = image.alt || data.title || '';
      if (zoomImage) {
        zoomImage.src = image.zoom || image.src;
        zoomImage.alt = image.alt || data.title || '';
      }
      thumbs.forEach((thumb, i) => thumb.classList.toggle('is-active', i === index));
      if (mediaCount) mediaCount.textContent = `${index + 1} / ${data.images.length}`;
    };

    const findVariant = () => {
      const sel = selectedValues();
      return data.variants.find(v => v.options.every((value, i) => sel[String(i + 1)] === value));
    };

    const updateDisplay = () => {
      if (!currentVariant) return;
      priceEls.forEach(el => el.textContent = money(currentVariant.price));
      totalEls.forEach(el => el.textContent = money(currentVariant.price * quantity));

      const hasCompare = currentVariant.compare_at_price && Number(currentVariant.compare_at_price) > Number(currentVariant.price);
      compareEls.forEach(el => {
        el.hidden = !hasCompare;
        if (hasCompare) el.textContent = 'MRP ' + money(currentVariant.compare_at_price);
      });
      discountEls.forEach(el => {
        el.hidden = !hasCompare;
        if (hasCompare) {
          const pct = Math.round((Number(currentVariant.compare_at_price) - Number(currentVariant.price)) * 100 / Number(currentVariant.compare_at_price));
          el.textContent = pct + '% OFF';
        }
      });

      stockEls.forEach(el => {
        el.textContent = currentVariant.available ? 'In stock' : 'Out of stock';
        el.classList.toggle('is-oos', !currentVariant.available);
      });
      addButtons.forEach(btn => {
        btn.disabled = !currentVariant.available;
        const label = btn.dataset.shortLabel === 'true'
          ? (currentVariant.available ? 'Add to cart' : 'Unavailable')
          : (currentVariant.available ? 'Add to Cart — ' + money(currentVariant.price * quantity) : 'Unavailable');
        btn.textContent = label;
      });

      if (selectedSku) selectedSku.textContent = currentVariant.sku || '—';

      if (currentVariant.featured_image && currentVariant.featured_image.src) {
        const needle = currentVariant.featured_image.src.split('?')[0].split('/').pop();
        const index = data.images.findIndex(img => img.src.includes(needle));
        if (index >= 0) setMainImage(index);
      }

      try {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', currentVariant.id);
        history.replaceState({}, '', url);
      } catch {}
    };

    variantButtons.forEach(btn => {
      btn.addEventListener('click', () => {
        const group = root.querySelectorAll(`[data-position="${btn.dataset.position}"]`);
        group.forEach(item => item.setAttribute('aria-pressed', item === btn ? 'true' : 'false'));

        const label = root.querySelector(`[data-selected-option="${btn.dataset.position}"]`);
        if (label) label.textContent = btn.dataset.value;

        const match = findVariant();
        if (match) {
          currentVariant = match;
          updateDisplay();
        }
      });
    });

    thumbs.forEach(thumb => thumb.addEventListener('click', () => setMainImage(Number(thumb.dataset.thumbIndex))));

    root.querySelector('[data-qty-minus]')?.addEventListener('click', () => {
      if (quantity > 1) quantity -= 1;
      if (qtyEl) qtyEl.textContent = quantity;
      updateDisplay();
    });
    root.querySelector('[data-qty-plus]')?.addEventListener('click', () => {
      quantity += 1;
      if (qtyEl) qtyEl.textContent = quantity;
      updateDisplay();
    });

    const addToCart = async (button) => {
      if (!currentVariant?.available || button.dataset.busy === 'true') return;
      button.dataset.busy = 'true';
      const old = button.textContent;
      button.textContent = 'Adding…';
      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
          body: JSON.stringify({id: currentVariant.id, quantity})
        });
        if (!response.ok) throw new Error('Cart request failed');
        window.location.href = '/cart';
      } catch {
        button.textContent = 'Try again';
        setTimeout(() => { button.textContent = old; button.dataset.busy = 'false'; }, 1800);
        return;
      }
    };
    addButtons.forEach(btn => btn.addEventListener('click', () => addToCart(btn)));

    root.querySelector('[data-share-product]')?.addEventListener('click', async () => {
      const payload = {title: data.title, url: window.location.href};
      if (navigator.share) {
        try { await navigator.share(payload); return; } catch {}
      }
      try {
        await navigator.clipboard.writeText(window.location.href);
        const share = root.querySelector('[data-share-product]');
        share.setAttribute('aria-label', 'Link copied');
      } catch {}
    });

    root.querySelector('[data-open-zoom]')?.addEventListener('click', () => {
      if (zoomDialog?.showModal) zoomDialog.showModal();
      else if (zoomImage?.src) window.open(zoomImage.src, '_blank', 'noopener');
    });
    root.querySelector('[data-close-zoom]')?.addEventListener('click', () => zoomDialog?.close());
    zoomDialog?.addEventListener('click', (e) => {
      if (e.target === zoomDialog) zoomDialog.close();
    });

    if (sticky && mainAdd) {
      const updateSticky = () => {
        if (window.innerWidth >= 750) {
          sticky.classList.remove('is-visible');
          return;
        }
        const rect = mainAdd.getBoundingClientRect();
        sticky.classList.toggle('is-visible', rect.bottom < 0);
      };
      window.addEventListener('scroll', updateSticky, {passive:true});
      window.addEventListener('resize', updateSticky, {passive:true});
      updateSticky();
    }

    updateDisplay();
  };

  const boot = () => document.querySelectorAll('[data-pdp-v3]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, {once:true});
  else boot();
  document.addEventListener('shopify:section:load', e => e.target.querySelectorAll?.('[data-pdp-v3]').forEach(init));
})();